import React, { Component  } from 'react';
import { withRouter } from 'react-router-dom';
import Webcam from 'react-webcam';
import { loadModels, getFullFaceDescription, createMatcher } from './face';
import DrawBox from './drawBox';
import { JSON_PROFILE } from './profile';

const WIDTH = 256;
const HEIGHT = 256;
const inputSize = 256;

class CameraFaceDetect extends Component {
   eyeRatioList = [];
  faceRatioList = [];
  noseMovementtList = [];
  faceNoseRatioList = [];
  ratioThreshold = 30; // Detect if movement within 30 data

  constructor(props) {
    super(props);
    this.webcam = React.createRef();
    this.state = {
      fullDesc: null,
      faceMatcher: null,
      facingMode: null,
      imageSrc: null,
      imageCanvas: null,
      faceNotDetectedCount: 0,
      faceNotMovementCount: 0,
      faceNotMovementDetected: false
    };
  }

  async componentDidMount(){
  }

  async componentWillMount() {
    await loadModels();
    this.setInputDevice();
    this.matcher();
  }

  setInputDevice = () => {
    navigator.mediaDevices.enumerateDevices().then(async devices => {
      let inputDevice = await devices.filter(
        device => device.kind === 'videoinput'
      );
      if (inputDevice.length < 2) {
        await this.setState({
          facingMode: 'environment'
        });
      } else {
        // await this.setState({
        //   facingMode:  { exact: 'environment' }
        // });

        await this.setState({
          facingMode: 'environment'
        });
      }
      this.startCapture();
    });
  };

  matcher = async () => {
    const faceMatcher = await createMatcher(JSON_PROFILE);
    this.setState({ faceMatcher });
  };

  startCapture = () => {
    this.interval = setInterval(() => {
      this.capture();
    }, 3000);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  capture = async () => {
    if (!!this.webcam.current) {
      const imageSrc = this.webcam.current.getScreenshot();
      const imageCanvas = this.webcam.current.getCanvas();
      if (imageSrc === null)
        return;
      
      //console.log("Capture");
      this.setState({ imageSrc: imageSrc, imageCanvas : imageCanvas },
        async () =>
          await getFullFaceDescription(
            imageSrc,
            inputSize
          ).then(fullDesc  => {

            if (fullDesc.length > 0){
              let fex = fullDesc[0].expressions;
              //console.log("FEX:Ang(" + fex.angry.toFixed(2) + ");Disg(" + fex.disgusted.toFixed(2) + ");Fear("+ fex.fearful.toFixed(2) + ");Happy(" + fex.happy.toFixed(2) + ");Neu(" + fex.neutral.toFixed(2) +");Sad("+ fex.sad.toFixed(2) + ");Surp(" + fex.surprised.toFixed(2) +")"); 
        
              //const imageCvs = this.webcam.current.getCanvas();
              // // Load the model.
              // cocoSsd.load().then(model => {
              //   // detect objects in the image.
              //   model.detect(imageCvs).then(predictions => {
              //     console.log('Predictions: ', predictions);
              //   });
              // });
             
              //console.log("Jaw : " + JSON.stringify(fl.getJawOutline()));
              //console.log("Left Eye1 : " + JSON.stringify(le)); 

              // let le2 =  le.map((p)=>{
              //     return {"x":p.x.toFixed(2), "y":p.y.toFixed(2),};
              //   }
              // )

              let fl = fullDesc[0].landmarks;

              let jaw = fl.getJawOutline();
              let nose = fl.getNose();
              let leb = fl.getLeftEyeBrow(); // Get Left Eye Brow
              let reb = fl.getRightEyeBrow(); // Get Right Eye Brow

              // console.log("Jaw : " + JSON.stringify(jaw)); 
              // console.log("Nose: " + JSON.stringify(nose)); 
              // console.log("LEB: " + JSON.stringify(leb)); 
              // console.log("REB: " + JSON.stringify(reb)); 

              // //---------------------------------------------------------------------
              // // Nose Jaw Dist Width
              // //---------------------------------------------------------------------
              // let faceWidth = this.euclidean([jaw[0].x, jaw[0].y], [jaw[jaw.length-1].x, jaw[jaw.length-1].y]);
              // let jawNoseDist1 = this.euclidean([jaw[0].x, jaw[0].y], [nose[0].x, nose[0].y]);
              // let jawNoseDist2 = this.euclidean([jaw[jaw.length-1].x, jaw[jaw.length-1].y], [nose[0].x, nose[0].y]);
              // let faceRatio1 = jawNoseDist1 / faceWidth;
              // let faceRatio2 = jawNoseDist2 / faceWidth;
              if (this.state.faceNotMovementDetected === false){

                if (this.noseMovementtList.length < this.ratioThreshold){
                  this.noseMovementtList.push({
                    "x": parseFloat(nose[0].x.toFixed(3)), 
                    "y": parseFloat(nose[0].y.toFixed(3))}
                  );
                  //console.log("Nose X : " + nose[0].x.toFixed(5) +"; Y : " + nose[0].y.toFixed(5));
                }else{

                  // Fraud Detection 
                  // Check if any movement by using centre face point on nose
                  let totalNoseXRatio = 0;
                  let totalNoseYRatio = 0;
                  this.noseMovementtList.map((ratio) => {
                    totalNoseXRatio += ratio.x;
                    totalNoseYRatio += ratio.y;
                  });

                  let avgXRatio = totalNoseXRatio / this.ratioThreshold;
                  let avgYRatio = totalNoseYRatio / this.ratioThreshold;
                  
                  let totalABSXRatio = 0;
                  let totalABSYRatio = 0;
                  this.noseMovementtList.map((ratio) => {
                    totalABSXRatio += Math.abs(avgXRatio - ratio.x);
                    totalABSYRatio += Math.abs(avgYRatio - ratio.y);
                  });

                  let avgABSXRatio = (totalABSXRatio / this.ratioThreshold)*100
                  let avgABSYRatio = (totalABSYRatio / this.ratioThreshold)*100
                                  
                  //console.log("TotalXRatio : " + totalABSXRatio.toFixed(5) +"; avgABSXRatio : " + avgABSXRatio.toFixed(5));
                  //console.log("TotalYRatio : " + totalABSYRatio.toFixed(5) +"; avgABSYRatio : " + avgABSYRatio.toFixed(5));

                  this.noseMovementtList = [];

                  if (totalABSXRatio < 80 && totalABSYRatio < 80){
                    console.log("No movement detected.")
                    this.setState({
                      faceNotMovementCount: this.state.faceNotMovementCount + 1
                    });
                  }
                }
              }
              
              // //---------------------------------------------------------------------
              // // Face Width
              // //---------------------------------------------------------------------
              // let faceWidth = this.euclidean([jaw[0].x, jaw[0].y], [jaw[jaw.length-1].x, jaw[jaw.length-1].y]);
              // let faceHeight1 = this.euclidean([leb[2].x, leb[2].y], [jaw[6].x, jaw[6].y]);
              // let faceHeight2 = this.euclidean([reb[2].x, reb[2].y], [jaw[10].x, jaw[10].y]);
              // let faceRatio = ((faceHeight1 + faceHeight2) / (2 * faceWidth));
             
              // if (this.faceRatioList.length < this.ratioThreshold){
              //   this.faceRatioList.push({
              //     "fr":parseFloat(faceRatio.toFixed(3))
              //   });
              //   console.log("Face Ratio : " + parseFloat(faceRatio.toFixed(3))); 
              // }else{
              //   // Fraud Detection 
              //   let totalFaceRatio = 0;
              //   this.faceRatioList.map((ratio) => {
              //     totalFaceRatio += ratio.fr;
              //   });

              //   let avgFaceRatio = totalFaceRatio / this.ratioThreshold;
                
              //   let totalABSFaceRatio = 0;
              //   this.faceRatioList.map((ratio) => {
              //     totalABSFaceRatio += Math.abs(avgFaceRatio - ratio.fr);
              //   });

              //   let avgABSFaceRatio = (totalABSFaceRatio / this.ratioThreshold)*100
                                
              //   console.log("TotalFaceRatio : " + totalFaceRatio.toFixed(5) +"; avgABSFaceRatio : " + avgABSFaceRatio.toFixed(5));
              //   this.faceRatioList = [];
              // }


              //---------------------------------------------------------------------
              //EYE
              //---------------------------------------------------------------------
              // let le = fl.getLeftEye();
              // let leftEyeWidth = this.euclidean([le[0].x, le[0].y], [le[3].x, le[3].y]);
              // let leftEyeHeight1 = this.euclidean([le[1].x, le[1].y], [le[5].x, le[5].y]);
              // let leftEyeHeight2 = this.euclidean([le[2].x, le[2].y], [le[4].x, le[4].y]);
              // let leftEyeRatio = ((leftEyeHeight1 + leftEyeHeight2) / (2 * leftEyeWidth));
              // //console.log("Left Eye1 (W)" + leftEyeWidth); 
              // //console.log("Left Eye1 (W):" + leftEyeWidth.toFixed(2) + ";(H1):" + leftEyeHeight1.toFixed(2)+ ";(H2):" + leftEyeHeight2.toFixed(2) + ";(R):"+leftEyeRatio.toFixed(2)); 

              // let re = fl.getRightEye();
              // let rightEyeWidth = this.euclidean([re[0].x, re[0].y], [re[3].x, re[3].y]);
              // let rightEyeHeight1 = this.euclidean([re[1].x, re[1].y], [re[5].x, re[5].y]);
              // let rightEyeHeight2 = this.euclidean([re[2].x, re[2].y], [re[4].x, re[4].y]);
              // let rightEyeRatio = ((rightEyeHeight1 + rightEyeHeight2) / (2 * rightEyeWidth));

              // if (this.eyeRatioList.length < this.ratioThreshold){
              //   this.eyeRatioList.push({
              //     "le":parseFloat(leftEyeRatio.toFixed(3)), 
              //     "re": parseFloat(rightEyeRatio.toFixed(3))}
              //   );
              //   console.log("Ratio : (L)" + parseFloat(leftEyeRatio.toFixed(3)) + " ; (R)" + parseFloat(rightEyeRatio.toFixed(3))); 
              // }else{
              //   // Fraud Detection 
              //   let totalLeftRatio = 0;
              //   let totalRightRatio = 0;
              //   this.eyeRatioList.map((ratio) => {
              //     totalLeftRatio += ratio.le;
              //     totalRightRatio += ratio.re;
              //   });

              //   let avgLeftRatio = totalLeftRatio / this.ratioThreshold
              //   let avgRightRatio = totalRightRatio / this.ratioThreshold
                
              //   let totalABSLeftRatio = 0;
              //   let totalABSRightRatio = 0;
              //   this.eyeRatioList.map((ratio) => {
              //     totalABSLeftRatio += Math.abs(avgLeftRatio - ratio.le);
              //     totalABSRightRatio += Math.abs(avgRightRatio - ratio.re);
              //   });

              //   let avgABSLeftRatio = (totalABSLeftRatio / this.ratioThreshold)*100
              //   let avgABSRightRatio = (totalABSRightRatio / this.ratioThreshold)*100
                                
              //   console.log("TotalLeftRatio : " + totalLeftRatio.toFixed(5) +"; avgABSLeftRatio : " + avgABSLeftRatio.toFixed(5));
              //   console.log("TotalRightRatio : " + totalRightRatio.toFixed(5) +"; avgABSRightRatio : " + avgABSRightRatio.toFixed(5));

              //   this.eyeRatioList = [];
              // }

            }

            this.setState({
              fullDesc,
              faceNotDetectedCount: (fullDesc === undefined || fullDesc.length === 0) ? this.state.faceNotDetectedCount + 1 : 0
            });
          })
      );
    }
  }
  

  euclidean = (p, q) => {
    if (p.length != q.length) return -1;
    const subtracted = q.map((i, n) => i - p[n]);
    const powered = subtracted.map(e => Math.pow(e, 2));
    const sum = powered.reduce((total, current) => total + current, 0)
    return Math.sqrt(sum);
  }

  render() {
    const { fullDesc, faceMatcher, facingMode, imageSrc, imageCanvas, faceNotDetectedCount, faceNotMovementCount } = this.state;
    let videoConstraints = null;
    let camera = 'Front';
    // if (!!facingMode) {
    //   videoConstraints = {
    //     width: WIDTH,
    //     height: HEIGHT,
    //     facingMode: facingMode
    //   };
    //   if (facingMode === 'user') {
    //     camera = 'Front';
    //   } else {
    //     camera = 'Back';
    //   }
    // }
    videoConstraints = {
      width: WIDTH,
      height: HEIGHT,
      facingMode: { exact: "user" }
    };

    if (faceNotMovementCount >= 1){
      if (this.state.faceNotMovementDetected === false){
        this.setState({faceNotMovementDetected: true}, () => {
          //console.log("=== > No movement detected");
          this.props.faceDetectStatus(false, imageSrc, 'No movement detected.');
          setTimeout(() => {  
            //console.log("Reset Movement Detection!");
            this.setState({faceNotMovementCount : 0, faceNotMovementDetected : false});
          }, 10000);
        })
      }
      //
    } else if (faceNotDetectedCount > 3) {
      //console.log("=== > faceNotDetectedCount more than 3");
      this.props.faceDetectStatus(false, imageSrc);
    } else {
      this.props.faceDetectStatus(true, imageSrc);
    }

    return (
      <div
        className="Camera"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {/* <p>Camera: {camera}</p> */}
        <div
          style={{
            width: WIDTH,
            height: HEIGHT
          }}
        >
          <div style={{ position: 'relative', width: WIDTH }}>
            {!!videoConstraints ? (
              <div style={{ position: 'absolute' }}>
                <Webcam 
                  audio={false}
                  width={WIDTH}
                  height={HEIGHT}
                  ref={this.webcam}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                />
              </div>
            ) : null}
            {!!fullDesc ? (
              <DrawBox
                fullDesc={fullDesc}
                faceMatcher={faceMatcher}
                imageWidth={WIDTH}
                boxColor={'blue'}
              />
            ) : null}
          </div>
        </div>

      </div>
    );
  }
}

export default withRouter(CameraFaceDetect);
